import * as React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

export const getFeelingArrows = (feeling: number): React.ReactNode => {
	if (feeling === 3) {
		return (
			<div className="flex items-center mr-2">
				<ArrowUp className="h-4 w-4 text-green-500" />
				<ArrowUp className="h-4 w-4 text-green-500" />
			</div>
		);
	} else if (feeling === 1) {
		return <ArrowUp className="h-4 w-4 text-green-500 mr-2" />;
	} else if (feeling === -1) {
		return <ArrowDown className="h-4 w-4 text-red-500 mr-2" />;
	} else if (feeling === -3) {
		return (
			<div className="flex items-center mr-2">
				<ArrowDown className="h-4 w-4 text-red-500" />
				<ArrowDown className="h-4 w-4 text-red-500" />
			</div>
		);
	}

	return null;
};

export const getFeelingText = (feeling: number | null): string => {
	switch (feeling) {
		case 3:
			return "Much better than my last daily reflection";
		case 1:
			return "Slightly better than my last daily reflection";
		case -1:
			return "Slightly worse than my last daily reflection";
		case -3:
			return "Much worse than my last daily reflection";
		default:
			return "Select your feeling...";
	}
};

export const getFeelingOptionWithArrows = (
	value: number,
	text: string,
): React.ReactNode => {
	return (
		<div className="flex items-center">
			{getFeelingArrows(value)}
			<span>{text}</span>
		</div>
	);
};
